import React from 'react';

//types
import { IIconProps } from 'assets/icons/IconProps';

export const FilterIcon = ({
  width = 24,
  height = 24,
  stroke = '#52575C',
  strokeWidth = 2,
}: IIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    fill="none"
    viewBox="0 0 24 24"
  >
    <path
      stroke={stroke}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M22 3H2l8 9.46V19l4 2v-8.54L22 3z"
    />
  </svg>
);
